// SERVICES
import OrderHeaderService from "../OrderHeaderService";


// STATE
const state =  {
	item:{},
	list:[],
	fields: [
		{
			key: 'id',
			label: '№',
			stickyColumn: true,
			sort: false,
			class: ['text-center', 'z']
		},
		{
			key: 'barcode',
			label: 'Спец-код',
			changebale: true
		},
		{
			key: 'name',
			label: 'Название',
			class: ['text-center', 'z']
		},
		{
			key: 'multiBarcodeString',
			label: ('Штрих-код'),
			class: ['text-center', 'z']
		},
		{
			key: 'artikul',
			label: 'Артикул',
			changebale: true
		},
		{
			key: 'subCategoryName',
			label: ('Группа'),
			class: ['text-center', 'z']
		},
		{
			key: 'sub2CategoryName',
			label: ('Категория'),
			class: ['text-center', 'z']
		},
		{
			key: 'sub3CategoryName',
			label: ('Под категория'),
			class: ['text-center', 'z']
		},
		{
			key: 'unitName',
			label: ('Ед. изм.'),
			class: ['text-center', 'z']
		},
		{
			key: 'actions',
			label: ('Действие '),
			class: ['text-center', 'z'],
			stickyColumn: true,
		}
	],
};

// GETTERS
const getters = {
	products(state){
		return state.data.list
	}
}

// ACTIONS
const actions = {
	async getList({commit}, data) {
		try {
			const res = await OrderHeaderService.getList(data)
			await commit('setListResponse', res);
		} catch (error) {
			await commit('setListResponse', error.response.data);
		}
	},
	async getById({commit},params) {
		try{
			const res = await OrderHeaderService.getById(params)
			await commit('setResponseById', res)
		}catch (error) {
			await commit('setResponseById',error.response.data)
		}
	},
}

// MUTATIONS
const mutations = {
	setResponseById(state, payload) {
		state.item = payload.data
	},
	setListResponse(state, payload) {

		state.list = payload.data.list
	},

}

export const excel = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
